export default __webpack_public_path__ + "static/media/select-caretup.e41c2026.svg";